export const getCookie = (name: string) => {
  if (process.browser) {
    const value = `; ${document.cookie}`
    const parts: any = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
  }
}

type SameSiteCookie = 'Strict' | 'Lax' | 'None'

export const setCookie = (
  cName: string,
  cValue: string,
  expDays: number,
  sameSite: SameSiteCookie = 'Lax'
) => {
  if (typeof window !== 'undefined') {
    const date = new Date()
    date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000)
    const expires = expDays ? 'expires=' + date.toUTCString() : ''
    const cookieOptions = []
    cookieOptions.push(`${cName}=${cValue}`)
    cookieOptions.push(expires)
    cookieOptions.push('path=/')
    cookieOptions.push(`SameSite=${sameSite}`)
    cookieOptions.push('Secure')
    document.cookie = cookieOptions.join('; ')
  }
}
